
(function () {
  if (!/\/collections\/free-gifts(\/|$)/.test(location.pathname)) return;

  var SEL = '#salepify-pb-collection';
  var BOX_ID = 'salepify-pb-unlock';
  var HERO_ID = 'salepify-pb-hero';
  var HEADING = 'Free gifts with your order!';
  var SUBHEADING = 'Choose a free gift with your qualifying order.';

  var CSS = `
:root {
  --sp-pb-accent: #0f8b74;
  --sp-pb-accent-soft: #e2f3ee;
  --sp-pb-idle: #9b9b9b;
  --sp-pb-ink: #111111;
  --sp-pb-sub: #5f5f5f;
}

/* ---------- Khối đầu trang: heading + track ---------- */
#${HERO_ID} {
  --sp-pb-on: var(--sp-pb-ink); --sp-pb-on-sub: var(--sp-pb-sub); --sp-pb-on-accent: var(--sp-pb-accent); --sp-pb-track: #dcdcdc;
  margin-top: 40px; text-align: center; color: var(--sp-pb-on);
}
#${HERO_ID} .sp-pb-heading {
  margin: 0; color: var(--sp-pb-on); font-size: 52px; font-weight: 800; line-height: 1.02; letter-spacing: -.02em; text-transform: none;
}
#${HERO_ID} .sp-pb-subheading { margin: 14px auto 0; max-width: 520px; color: var(--sp-pb-on-sub); font-size: 19px; line-height: 1.4; }
${SEL} { width: 100%; max-width: 480px; margin: 8px auto 0; }
${SEL} .tl__cart-goal__container__drawer {
  padding: 0 !important; background: transparent !important; border: 0 !important; border-radius: 0 !important;
  font-family: inherit !important; animation: none !important;
}
${SEL} .tl__cart-goal__reward-description__drawer,
${SEL} [class^="tl__cart-goal__free-gift-container"],
${SEL} .tl-cart-goal-countdown { display: none !important; }
${SEL} .ptrack { height: 3px !important; margin: 28px 27px 62px !important; background: var(--sp-pb-track) !important; }
${SEL} .tl__cart-goal__goal-process__drawer { background: var(--sp-pb-accent) !important; }
${SEL} .pnode, ${SEL} .pcirc { width: 46px !important; height: 46px !important; }
${SEL} .pcirc { background: var(--sp-pb-idle) !important; border: 0 !important; }
${SEL} .pnode.is-reached .pcirc { background: var(--sp-pb-accent) !important; }
${SEL} .pcirc .tl__cart-goal__milestone-image { width: 20px !important; height: 20px !important; filter: brightness(0) invert(1) !important; }
${SEL} .pabove, ${SEL} .pbelow {
  opacity: 1 !important; font-family: inherit !important; text-transform: none !important; letter-spacing: 0 !important;
  color: var(--sp-pb-on) !important; text-align: center !important; bottom: auto !important;
}
${SEL} .pabove { top: calc(100% + 10px) !important; font-size: 18px !important; font-weight: 700 !important; }
${SEL} .pbelow { top: calc(100% + 34px) !important; font-size: 15px !important; font-weight: 400 !important; }
${SEL} .pnode.sp-current .pabove, ${SEL} .pnode.sp-current .pbelow { color: var(--sp-pb-on-accent) !important; }

/* ---------- Ô unlocked dưới banner ---------- */
#${BOX_ID} { margin: 24px auto; }
#${BOX_ID} .sp-pb-card {
  display: flex; align-items: center; gap: 18px; padding: 22px 26px;
  background: var(--sp-pb-accent-soft); border-radius: 10px; color: var(--sp-pb-ink);
}
#${BOX_ID} .sp-pb-icon {
  flex: none; display: grid; place-items: center; width: 44px; height: 44px; border-radius: 50%;
  background: var(--sp-pb-accent); color: #fff;
}
#${BOX_ID} .sp-pb-icon svg { width: 22px; height: 22px; }
#${BOX_ID} .sp-pb-text { flex: 1; min-width: 0; }
#${BOX_ID} .sp-pb-title { margin: 0; font-size: 22px; font-weight: 700; line-height: 1.2; }
#${BOX_ID} .sp-pb-sub { margin: 4px 0 0; font-size: 15px; color: var(--sp-pb-sub); }
#${BOX_ID} .sp-pb-btn {
  flex: none; display: inline-flex; align-items: center; gap: 12px; padding: 16px 30px;
  background: var(--sp-pb-ink); color: #fff; border: 0; border-radius: 8px; cursor: pointer;
  font: inherit; font-size: 17px; font-weight: 600;
}
#${BOX_ID} .sp-pb-btn svg { width: 22px; height: 22px; }
#${BOX_ID} .sp-pb-card.is-locked .sp-pb-icon { background: var(--sp-pb-idle); }
#${BOX_ID} > p { margin-top: 8px !important; }
#${BOX_ID} [hidden], #${BOX_ID}[hidden], #${HERO_ID}[hidden] { display: none !important; }
@media (max-width: 749px) {
  #${BOX_ID} .sp-pb-card { flex-wrap: wrap; padding: 18px; }
  #${BOX_ID} .sp-pb-title { font-size: 18px; }
  #${BOX_ID} .sp-pb-btn { width: 100%; justify-content: center; }
  #${HERO_ID} { margin-top: 24px; }
  #${HERO_ID} .sp-pb-heading { font-size: 32px; }
  #${HERO_ID} .sp-pb-subheading { font-size: 16px; }
  ${SEL} .pabove { font-size: 15px !important; }
  ${SEL} .pbelow { font-size: 13px !important; }
}

/* ---------- Modal quà: panel bên phải ---------- */
dialog.tl__cart-goal__gift-modal .tl__cart-goal__list-gifts {
  top: 0 !important; right: 0 !important; left: auto !important; transform: none !important;
  width: min(520px, 100vw) !important; max-width: none !important; height: 100vh !important; max-height: 100vh !important;
  box-sizing: border-box; padding: 40px 28px 24px !important; border: 0 !important; border-radius: 0 !important;
  align-items: stretch !important; background: #fff !important; color: var(--sp-pb-ink) !important;
  font-family: inherit !important; animation: spPbSlideIn .3s cubic-bezier(.2,.8,.2,1) both !important;
}
dialog.tl__cart-goal__gift-modal .tl__cart-goal__list-gifts > span:first-child {
  max-height: none !important; padding: 0 0 16px !important; font-size: 30px !important; font-weight: 700 !important; line-height: 1.15;
}
dialog.tl__cart-goal__gift-modal .tl_selected_quantity {
  display: block; margin-top: 8px; padding: 0 !important; background: none !important;
  font-size: 17px !important; font-weight: 400 !important; color: var(--sp-pb-sub) !important;
}
/* App set inline color: red khi chọn quá số lượng */
dialog.tl__cart-goal__gift-modal .tl_selected_quantity[style*="red"] { color: #d72c0d !important; font-weight: 600 !important; }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__list-gifts > div:nth-of-type(1) {
  flex: 1; max-height: none !important; gap: 14px !important; padding: 4px 2px !important;
}
dialog.tl__cart-goal__gift-modal .tl__cart-goal__free-gift-reward-body {
  box-sizing: border-box; padding: 14px; border: 1px solid #e6e6e6; border-radius: 10px; cursor: pointer;
}
dialog.tl__cart-goal__gift-modal .tl__cart-goal__product-image { min-width: 110px; max-width: 110px; height: 110px; }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__product-image img { object-fit: contain; border-radius: 6px; }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__product-quantity { display: none; }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__product-image-info > p { font-size: 19px !important; font-weight: 700 !important; line-height: 1.25 !important; margin-bottom: 6px !important; }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__product-image-info > span { font-family: inherit !important; font-size: 15px !important; color: var(--sp-pb-sub); }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__product-image-info > span:nth-child(3) { background: var(--sp-pb-accent) !important; color: #fff; }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__check-box {
  flex: none; display: inline-flex !important; align-items: center; justify-content: center; box-sizing: border-box;
  width: 96px !important; min-width: 96px !important; height: 46px !important; margin: 0 !important; padding: 0;
  border: 1.5px solid var(--sp-pb-ink) !important; border-radius: 8px !important; outline: 0 !important; background: #fff !important;
}
dialog.tl__cart-goal__gift-modal .tl__cart-goal__check-box::after { content: "Select"; font-size: 16px; font-weight: 600; line-height: 1; color: var(--sp-pb-ink); }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__check-box--active {
  position: absolute; top: 14px; right: 14px; display: grid !important; place-items: center;
  width: 30px !important; min-width: 30px !important; height: 30px !important; padding: 0; border: 0 !important; border-radius: 50% !important;
  background: var(--sp-pb-accent) !important;
}
dialog.tl__cart-goal__gift-modal .tl__cart-goal__check-box--active::after { content: "\\2713"; color: #fff; font-size: 16px; }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__free-gift-reward-body:has(.tl__cart-goal__check-box--active) { border-color: var(--sp-pb-accent); }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__list-gifts > div:has(> .tl__cart-goal__button-add-gift) {
  flex-direction: column-reverse !important; height: auto !important; gap: 10px; font-size: 16px !important;
}
dialog.tl__cart-goal__gift-modal .tl__cart-goal__button-add-gift,
dialog.tl__cart-goal__gift-modal .tl__cart-goal__button-cancel-gift {
  width: 100% !important; margin: 0 !important; font-family: inherit !important; text-transform: none !important; letter-spacing: 0 !important;
}
dialog.tl__cart-goal__gift-modal .tl__cart-goal__button-add-gift {
  min-height: 62px; background: var(--sp-pb-ink) !important; color: #fff !important; border-radius: 8px !important;
  font-size: 18px !important; font-weight: 600 !important;
}
dialog.tl__cart-goal__gift-modal .tl__cart-goal__button-add-gift::after { content: " \\2192"; margin-left: 8px; }
dialog.tl__cart-goal__gift-modal .tl__cart-goal__button-cancel-gift {
  min-height: 40px; border: 0 !important; color: var(--sp-pb-sub) !important; font-size: 15px !important; text-decoration: underline;
}
dialog.tl__cart-goal__gift-modal .sp-pb-close {
  position: absolute; top: 14px; right: 16px; display: grid; place-items: center; width: 36px; height: 36px; padding: 0;
  background: none; border: 0; cursor: pointer; color: var(--sp-pb-ink); font-size: 30px; line-height: 1;
}
dialog.tl__cart-goal__gift-modal .tl__cart-goal__list-gifts > span:first-child { padding-right: 40px !important; }
dialog.tl__cart-goal__gift-modal[open] { animation: spPbFadeIn .25s ease-out both; }
dialog.tl__cart-goal__gift-modal.sp-closing { animation: spPbFadeOut .22s ease-in both; }
dialog.tl__cart-goal__gift-modal.sp-closing .tl__cart-goal__list-gifts { animation: spPbSlideOut .22s ease-in both !important; }
@keyframes spPbSlideIn { from { transform: translateX(100%); } to { transform: translateX(0); } }
@keyframes spPbSlideOut { from { transform: translateX(0); } to { transform: translateX(100%); } }
@keyframes spPbFadeIn { from { background-color: rgba(0,0,0,0); } }
@keyframes spPbFadeOut { to { background-color: rgba(0,0,0,0); } }
@media (prefers-reduced-motion: reduce) {
  dialog.tl__cart-goal__gift-modal, dialog.tl__cart-goal__gift-modal .tl__cart-goal__list-gifts { animation: none !important; }
}
`;

  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var ICON_GIFT = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 7h-2.2A3 3 0 0 0 12 3.8 3 3 0 0 0 6.2 7H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h7V7h2v5h7a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM9 7a1 1 0 1 1 1-1v1H9zm6 0h-1V6a1 1 0 1 1 1 1zM4 13v7a1 1 0 0 0 1 1h6v-8H4zm9 8h6a1 1 0 0 0 1-1v-7h-7v8z"/></svg>';

  function mountPlaceholder() {
    if (document.querySelector(SEL)) return true;
    // Section đầu trang là banner hero -> widget chèn ngay dưới nó
    var anchor = document.querySelector('.main-content > .shopify-section') || document.querySelector('main .shopify-section');
    if (!anchor) return false;
    var wrap = document.createElement('div');
    wrap.id = HERO_ID;
    wrap.className = 'page-width';
    wrap.hidden = true;
    wrap.innerHTML = '<h2 class="sp-pb-heading"></h2><p class="sp-pb-subheading"></p><div id="' + SEL.slice(1) + '"></div>';
    wrap.querySelector('.sp-pb-heading').textContent = HEADING;
    wrap.querySelector('.sp-pb-subheading').textContent = SUBHEADING;

    var box = document.createElement('div');
    box.id = BOX_ID;
    box.className = 'page-width';
    anchor.insertAdjacentElement('afterend', wrap);
    wrap.insertAdjacentElement('afterend', box);
    box.addEventListener('click', function (ev) {
      try {
        if (!ev.target.closest('.sp-pb-btn')) return;
        // Mở modal của mốc quà đầu tiên chưa nhận, dùng nguyên handler của app
        var next = document.querySelector(SEL + ' [class^="tl__cart-goal__free-gift-container"] .prewbtn');
        if (next) next.click();
      } catch (err) { warn(err); }
    });

    // Capture phase: dialog của app chặn stopPropagation nên bubble không tới document
    document.addEventListener('click', function (ev) {
      try {
        var t = ev.target;
        if (!(t instanceof Element)) return;
        var dialog = t.closest('dialog.tl__cart-goal__gift-modal');
        if (dialog && (t === dialog || t.closest('.sp-pb-close'))) dialog.close();
      } catch (err) { warn(err); }
    }, true);

    var style = document.createElement('style');
    style.id = 'salepify-pb-collection-style';
    style.textContent = CSS;
    document.head.appendChild(style);
    return true;
  }

  function warn(err) {
    if (window.console) console.warn('[Salepify custom] collection progress bar:', err);
  }

  function money(amount) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat((window.Shopify && Shopify.locale) || 'en', { style: 'currency', currency: cur }).format(amount);
    } catch (_) {
      return amount + ' ' + cur;
    }
  }

  var CLOSE_MS = 220;
  var nativeClose = window.HTMLDialogElement && HTMLDialogElement.prototype.close;

  // Mọi đường đóng (X, backdrop, Cancel, Esc, app tự đóng sau Confirm) đều qua dialog.close() -> chạy animation rồi mới đóng thật
  function animateClose(d) {
    if (d.__spPbAnimated || !nativeClose) return;
    d.__spPbAnimated = true;
    d.close = function () {
      var self = this, args = arguments;
      try {
        if (!self.open || self.classList.contains('sp-closing')) return;
        if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return nativeClose.apply(self, args);
        self.classList.add('sp-closing');
        setTimeout(function () {
          self.classList.remove('sp-closing');
          if (self.open) nativeClose.apply(self, args);
        }, CLOSE_MS);
      } catch (err) {
        warn(err);
        self.classList.remove('sp-closing');
        nativeClose.apply(self, args);
      }
    };
    d.addEventListener('cancel', function (ev) {
      ev.preventDefault();
      d.close();
    });
  }

  // App dựng lại innerHTML modal mỗi lần render -> gắn lại nút X
  function ensureCloseButtons() {
    document.querySelectorAll('dialog.tl__cart-goal__gift-modal').forEach(animateClose);
    document.querySelectorAll('dialog.tl__cart-goal__gift-modal .tl__cart-goal__list-gifts').forEach(function (list) {
      if (list.querySelector('.sp-pb-close')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sp-pb-close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      list.appendChild(btn);
    });
  }

  function render(e) {
    ensureCloseButtons();
    var ph = document.querySelector(SEL);
    var box = document.getElementById(BOX_ID);
    if (!ph || !box) return;

    var reached = ph.querySelectorAll('.pnode.is-reached');
    ph.querySelectorAll('.pnode').forEach(function (n) {
      var cur = n === reached[reached.length - 1];
      if (n.classList.contains('sp-current') !== cur) n.classList.toggle('sp-current', cur);
    });

// Remove "Powered by Tek Labs"
var brand = ph.querySelector('a[href*="tek-labs"]');
if (brand) {
  var p = brand.closest('p');
  (p || brand).remove();
}
box.querySelectorAll('.sp-pb-brand').forEach(function (el) {
  el.remove();
});

    var hasWidget = !!ph.querySelector('.tl__cart-goal__container__drawer');
    var wrap = document.getElementById(HERO_ID);
    if (wrap) wrap.hidden = !hasWidget;
    box.hidden = !hasWidget;
    if (!hasWidget) return;

    var rows = ph.querySelectorAll('[class^="tl__cart-goal__free-gift-container"] .prow');
    var unclaimed = ph.querySelectorAll('[class^="tl__cart-goal__free-gift-container"] .prewbtn').length;
    var count = rows.length;
    var desc = ph.querySelector('.tl__cart-goal__reward-description__drawer');

    var title, sub = '', showBtn = false;
    if (!count) {
      title = desc ? desc.textContent.trim() : '';
    } else if (unclaimed) {
      title = "You've unlocked " + count + ' free gift' + (count > 1 ? 's' : '') + '. Please only select 1 gift at a time';
      sub = 'Your current qualifying subtotal is ' + money(e.cartTotal) + '.';
      if (count > unclaimed) sub += ' ' + (count - unclaimed) + ' of ' + count + ' gifts added.';
      showBtn = true;
    } else {
      title = 'Your free gift' + (count > 1 ? 's are' : ' is') + ' in your cart';
      sub = desc ? desc.textContent.trim() : '';
    }

    var card = box.querySelector('.sp-pb-card');
    if (!card) {
      card = document.createElement('div');
      card.className = 'sp-pb-card';
      card.innerHTML =
        '<span class="sp-pb-icon"></span>' +
        '<div class="sp-pb-text"><p class="sp-pb-title"></p><p class="sp-pb-sub"></p></div>' +
        '<button type="button" class="sp-pb-btn">' + ICON_GIFT + '<span>Choose my free gifts</span><span aria-hidden="true">&rarr;</span></button>';
      box.prepend(card);
    }
    card.classList.toggle('is-locked', !count);
    card.querySelector('.sp-pb-icon').innerHTML = count ? ICON_CHECK : ICON_GIFT;
    card.querySelector('.sp-pb-title').textContent = title;
    card.querySelector('.sp-pb-sub').textContent = sub;
    card.querySelector('.sp-pb-sub').hidden = !sub;
    card.querySelector('.sp-pb-btn').hidden = !showBtn;
  }

  function patch(e) {
    if (e.__tlCollectionPatched) return;
    e.__tlCollectionPatched = true;
    // App gán lại 2 field này khi load rule xong -> khoá bằng getter, setter bỏ qua
    Object.defineProperty(e, 'defaultProductPageSelector', { get: function () { return SEL; }, set: function () {}, configurable: true });
    Object.defineProperty(e, 'defaultProductPagePosition', { get: function () { return 'prepend'; }, set: function () {}, configurable: true });
    var orig = e.getWidgetVisibility.bind(e);
    e.getWidgetVisibility = function (s) {
      var v = orig(s);
      try { v.productPage = true; } catch (err) { warn(err); }
      return v;
    };

    // App render lại / cập nhật tại chỗ khi cart đổi -> dựng lại ô unlocked
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        try { render(e); } catch (err) { warn(err); }
      });
    }).observe(document.querySelector(SEL), { childList: true, subtree: true, characterData: true });

    // discountCode chỉ có khi rule đã load; app render trước khi patch thì render lại
    if (e.discountCode) e.renderAllCartGoals();
    render(e);
  }

  var tries = 0;
  (function wait() {
    try {
      var e = window.tlCartGoalEmbed;
      if (e && mountPlaceholder()) return patch(e);
    } catch (err) {
      return warn(err);
    }
    if (++tries < 100) setTimeout(wait, 100);
  })();
})();
